export default {
    persons (state) {
      return state.persons
    },

    selectedPerson (state) {
        return state.selectedPerson
    },

    getPerson: state => (personId) => {
      return state.persons.find(person => person.staffId === personId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/persons/getters.js